<template>
  <div class="container">
    <el-form size="mini" :model="searchInfo" inline>
      <el-form-item label="账务时间：" prop="trade_time">
        <!-- <el-date-picker
          v-model="searchInfo.trade_time"
          type="daterange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          @change="handleSearch"
          value-format="timestamp"
          :picker-options="effectiveDate"
          :clearable="false"
        >
        </el-date-picker> -->
        <common-date-range-selector
          v-model="searchInfo.trade_time"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          @change="handleSearch"
          value-format="timestamp"
          :picker-options="effectiveDate"
          :clearable="false"
        >
        </common-date-range-selector>
      </el-form-item>
      <el-form-item label="订单号：" prop="biz_id">
        <el-input
          v-model="searchInfo.biz_id"
          placeholder="请输入订单号"
          @change="handleSearch"
          clearable
          prefix-icon="el-icon-search"
          maxlength="999"
        ></el-input>
      </el-form-item>
      <el-form-item label="学员：" prop="student_id">
        <el-select
          v-model.number="searchInfo.student_id"
          filterable
          clearable
          placeholder="请选择"
          @clear="handleSearchStudent('')"
          :filter-method="handleSearchStudent"
          @visible-change="handleStudentVisible"
          @change="handleSearch"
        >
          <el-option
            v-for="item in studentList"
            :key="item.student_id"
            :label="item.name"
            :value="item.student_id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="收支类型：" prop="log_type">
        <el-radio-group v-model="searchInfo.log_type" @change="handleSearch">
          <el-radio-button :label="-1">全部</el-radio-button>
          <el-radio-button :label="1">收入</el-radio-button>
          <el-radio-button :label="2">支出</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="账务类型：" prop="biz_code">
        <el-select
          v-model="searchInfo.trade_types"
          clearable
          placeholder="请选择"
          @change="handleSearch"
          multiple
        >
          <el-option
            v-for="item in tradeTypeList"
            :key="item.trade_type"
            :label="item.label"
            :value="item.trade_type"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 12px">
      <div class="mwow-button-filled success" @click="handleExport">导出</div>
    </div>
    <el-table
      class="mwow-table"
      v-horizontal-scroll
      size="mini"
      :data="tableData"
      stripe
      style="width: 100%"
      tooltip-effect="dark"
    >
      <el-table-column label="账务时间" prop="trade_time"></el-table-column>
      <el-table-column label="收支类型" prop="log_type">
        <template slot-scope="scope">
          <span>{{ scope.row.log_type === 1 ? "收入" : "支出" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="账务类型" prop="trade_type">
        <template slot-scope="scope">
          {{ handleTradeType(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column
        label="收支金额(元)"
        prop="settle_amount"
        min-width="90px"
      >
        <template slot-scope="scope">
          {{ scope.row.log_type === 1 ? "+" : "-" }}
          {{ scope.row.settle_amount ? scope.row.settle_amount : 0 }}
        </template>
      </el-table-column>
      <el-table-column label="学员姓名" prop="student.name">
        <template slot-scope="scope">
          <div
            v-if="
              scope.row.trade_type === 1 ||
              scope.row.trade_type === 10 ||
              scope.row.trade_type === 20
            "
          >
            -
          </div>
          <div v-else>
            {{ scope.row.student ? scope.row.student.name : "-" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="学员手机号" prop="student.mobile">
        <template slot-scope="scope">
          {{ scope.row.student ? scope.row.student.mobile : "-" }}
        </template>
      </el-table-column>
      <el-table-column label="交易流水号" prop="order_no">
        <template slot-scope="scope">
          {{ scope.row.order_no ? scope.row.order_no : "-" }}
        </template>
      </el-table-column>
      <el-table-column label="订单号" prop="biz_id">
        <template slot-scope="scope">
          <div class="link" @click="handleClickBiz(scope.row)">
            {{ scope.row.biz_id ? scope.row.biz_id : "-" }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      :style="{ float: 'right', padding: '20px' }"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
  </div>
</template>
<script>
import { exportLoop } from "@/utils/export";
import { dateFormat } from "@/utils/timeFormat";
import { getBillDetailApi, exportBillDetailApi } from "@/api/storeWallet";
import { searchStudent } from "@/api/globalSearch";
import { PageModule } from "@/store/module/page";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

export default {
  components: {
    commonDateRangeSelector,
  },
  data() {
    return {
      searchInfo: {
        log_type: -1,
        biz_code: -1,
        trade_time: [],
      },
      studentList: [],
      tradeTypeList: [
        {
          label: "提现",
          trade_type: "1",
        },
        {
          label: "收款",
          trade_type: "2",
        },
        {
          label: "退款",
          trade_type: "3",
        },
        {
          label: "充值",
          trade_type: "5",
        },
        {
          label: "服务费",
          trade_type: "10",
        },
        {
          label: "退服务费",
          trade_type: "11",
        },
        {
          label: "手续费",
          trade_type: "20",
        },
        {
          label: "退手续费",
          trade_type: "21",
        },
      ],
      tableData: [],
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      // 未来时间应不可选
      effectiveDate: {
        disabledDate(date) {
          return date.getTime() > Date.now();
        },
      },
    };
  },

  created() {
    // 从 vuex 中获取页面缓存数据
    const searchListInfo = PageModule.pageInfo.storeWalletTabDetail;
    if (searchListInfo.search_info) {
      this.searchInfo = searchListInfo.search_info;
    } else {
      let now = new Date();
      let end =
        now.getFullYear() +
        "/" +
        (now.getMonth() + 1) +
        "/" +
        now.getDate() +
        " 00:00:00";
      this.searchInfo.trade_time = [
        new Date(end).getTime() - 365 * 24 * 60 * 60 * 1000,
        new Date(end).getTime(),
      ];
    }
    if (searchListInfo.page) {
      this.page = searchListInfo.page;
    }
    if (searchListInfo.page_size) {
      this.pageSize = searchListInfo.page_size;
    }
    // 只有从订单详情返回时，需要对 page 缓存，其他页面不需要
    const routerFrom = this.$route.query.from;
    if (routerFrom !== "order_detail") {
      this.page = 1;
    } else {
      // 会话清除
      setTimeout(() => {
        sessionStorage.removeItem("finance");
      }, 1000);
    }
    this.handleSearchStudent("");
    this.getList({
      page: this.page,
      page_size: this.pageSize,
    });
  },
  methods: {
    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    getList(params) {
      const option = {
        page: params.page,
        page_size: params.page_size,
      };
      if (
        this.searchInfo.trade_time &&
        this.searchInfo.trade_time.length === 2
      ) {
        option.trade_time_start = this.searchInfo.trade_time[0] / 1000;
        option.trade_time_end =
          this.searchInfo.trade_time[1] / 1000 + 24 * 60 * 60 - 1;
      }
      if (this.searchInfo.biz_id) {
        option.biz_id = this.searchInfo.biz_id;
      }
      if (this.searchInfo.student_id) {
        option.student_id = this.searchInfo.student_id;
      }
      if (this.searchInfo.log_type >= 0) {
        option.log_type = this.searchInfo.log_type;
      }
      // if (this.searchInfo.biz_code >= 0) {
      //   option.biz_code = this.searchInfo.biz_code;
      // }
      if (
        this.searchInfo.trade_types &&
        this.searchInfo.trade_types.length > 0
      ) {
        option.trade_types = this.searchInfo.trade_types;
      }
      getBillDetailApi(option).then((res) => {
        this.page = res.data.page;
        this.total = res.data.total;
        res.data.list.map((item) => {
          // 创建时间读取交易时间的值
          item.trade_time =
            item.trade_time === 0
              ? "-"
              : dateFormat("YYYY-mm-dd HH:MM", item.trade_time * 1000);
        });
        this.tableData = res.data.list;
      });
    },
    handleSearchStudent(v) {
      searchStudent({
        page: 1,
        page_size: 50,
        key_word: v || "",
      }).then((res) => {
        if (res.error_code === 0) {
          this.studentList = res.data.list;
        }
      });
    },
    handleStudentVisible(rest) {
      if (rest) {
        this.handleSearchStudent();
      }
    },
    handleTradeType(row) {
      let text;
      if (row.trade_type === 1) {
        text = "提现";
      } else if (row.trade_type === 2) {
        text = "收款";
      } else if (row.trade_type === 3) {
        text = "退款";
      } else if (row.trade_type === 5) {
        text = "充值";
      } else if (row.trade_type === 10) {
        text = "服务费";
      } else if (row.trade_type === 11) {
        text = "退服务费";
      } else if (row.trade_type === 20) {
        text = "手续费";
      } else if (row.trade_type === 21) {
        text = "退手续费";
      } else {
        text = "-";
      }
      return text;
    },
    // 缓存需要的数据
    cachePageInfo() {
      PageModule.SET_PAGE_INFO({
        name: "storeWalletTabDetail",
        key: "search_info",
        value: this.searchInfo,
      });
      PageModule.SET_PAGE_INFO({
        name: "storeWalletTabDetail",
        key: "page",
        value: this.page,
      });
      PageModule.SET_PAGE_INFO({
        name: "storeWalletTabDetail",
        key: "page_size",
        value: this.pageSize,
      });
    },
    handleClickBiz(row) {
      // 跳转前，将 searchInfo、page 数据缓存，等返回时使用
      sessionStorage.setItem(
        "finance",
        JSON.stringify("storeWallet_Tabdetail")
      );
      this.cachePageInfo();
      if (row.biz_id) {
        this.$router.push({
          name: "orderManageDetail",
          query: {
            ono: row.biz_id,
          },
        });
      }
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
    handleExport() {
      const option = {};
      if (
        this.searchInfo.trade_time &&
        this.searchInfo.trade_time.length >= 0
      ) {
        option.trade_time_start = this.searchInfo.trade_time[0] / 1000;
        option.trade_time_end =
          this.searchInfo.trade_time[1] / 1000 + 24 * 60 * 60 - 1;
      } else {
        return this.$message.warning({
          message: "导出必须选定时间范围且不能超过一年",
        });
      }
      if (this.searchInfo.biz_id) {
        option.biz_id = this.searchInfo.biz_id;
      }
      if (this.searchInfo.student_id) {
        option.student_id = this.searchInfo.student_id;
      }
      if (this.searchInfo.log_type >= 0) {
        option.log_type = this.searchInfo.log_type;
      }
      // if (this.searchInfo.biz_code >= 0) {
      //   option.biz_code = this.searchInfo.biz_code;
      // }
      if (this.searchInfo.trade_types >= 0) {
        option.trade_types = this.searchInfo.trade_types;
      }
      exportBillDetailApi(option).then((res) => {
        console.log(res);
        exportLoop(res.data.task_id);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.link {
  color: #07d1aa;
  &:hover {
    cursor: pointer;
  }
}
</style>
